<template>
  <div class="dynamic-by-source-and-gsm-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <bar-chart-dynamic
      v-if="isLoaded"
      :chart-data="dataBarCollection"
      :options="barOptions"
      class="dynamic-by-source-and-gsm-content__chart"
    ></bar-chart-dynamic>
    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.analytics.sourceAndGsm.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { BarChartDynamic } from "../../../../../../../../components/charts";

  // mixins
  import dynamicBySourceAndGsm from "../../../../../../../../mixins/chart/dynamicBySourceAndGsm";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import source from "../../../../../../../../config/source";

  // moment
  import moment from 'moment';

  // vuex
  import { mapGetters } from "vuex";

  export default {
    name: "DynamicBySourceAndGsmBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      chartName: {
        type: String
      },
      title: {
        type: String
      },
    },
    data() {
      return {
        source: source,
        chartId: "DynamicBySourceAndGsm",
        format: "DD.MM.YYYY",
        showLabel: true,
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      ...mapGetters([
        "socialList",
      ]),
      chartDate() {
        return this.$store.getters.getPeriod(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
      isLoaded() {
        return this.$store.getters.isLoaded(this.chartName);
      }
    },
    mixins: [
      dynamicBySourceAndGsm,
      saveImage
    ],
    components: {
      BarChartDynamic
    }
  };
</script>

<style>
  @import "../../../../../../../../style/legendList.css";

  .dynamic-by-source-and-gsm-content__chart {
    margin-bottom: 10px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
  @media screen and (max-width: 480px) {
    .dynamic-by-source-and-gsm-content__chart {
      width: 90vw;
    }
  }
</style>
